(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bandeau-compte-a-rebours"] && !Shopify.designMode) return;
  try {
    
  class BandeauCountdownTimer extends HTMLElement {
    connectedCallback() {
      this.endMs = parseInt(this.dataset.end, 10) * 1000;
      this.values = {
        jours: this.querySelector('[data-unit="jours"]'),
        heures: this.querySelector('[data-unit="heures"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        secondes: this.querySelector('[data-unit="secondes"]')
      };
      this.timerEl = this.querySelector('.bandeau-cr__timer');
      this.surTitleEl = this.querySelector('.bandeau-cr__sur-titre');
      this.titleEl = this.querySelector('.bandeau-cr__titre');
      this.subtitleEl = this.querySelector('.bandeau-cr__sous-titre');
      this.messageEl = this.querySelector('.bandeau-cr__message');
      this.inscriptionEl = this.querySelector('.bandeau-cr__inscription');
      this.designMode = this.dataset.designMode === 'true';

      this.tick = this.tick.bind(this);
      this.tick();
      this.interval = setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const totalSeconds = Math.max(0, Math.floor((this.endMs - Date.now()) / 1000));

      this.render(totalSeconds);

      if (totalSeconds <= 0) {
        clearInterval(this.interval);
        this.expire();
      }
    }

    render(totalSeconds) {
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.values.jours.textContent = String(days).padStart(2, '0');
      this.values.heures.textContent = String(hours).padStart(2, '0');
      this.values.minutes.textContent = String(minutes).padStart(2, '0');
      this.values.secondes.textContent = String(seconds).padStart(2, '0');
    }

    expire() {
      // Dans l'éditeur de thème, on garde la section visible pour pouvoir la régler.
      if (this.designMode) {
        if (this.messageEl) this.messageEl.hidden = false;
        return;
      }

      if (this.dataset.expiry === 'masquer') {
        const wrapper = this.closest('.shopify-section');
        if (wrapper) wrapper.style.display = 'none';
        return;
      }

      this.timerEl.hidden = true;
      if (this.surTitleEl) this.surTitleEl.hidden = true;
      if (this.titleEl) this.titleEl.hidden = true;
      if (this.subtitleEl) this.subtitleEl.hidden = true;
      // l'événement est arrivé : plus de raison de proposer d'être prévenue
      if (this.inscriptionEl) this.inscriptionEl.hidden = true;
      if (this.messageEl) this.messageEl.hidden = false;
    }
  }

  if (!customElements.get('bandeau-countdown-timer')) {
    customElements.define('bandeau-countdown-timer', BandeauCountdownTimer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-reliabijoux"] && !Shopify.designMode) return;
  try {
    
  /* Lien direct vers une question (#ancre) : ouvre la question et sa catégorie,
     puis centre la question sous l'en-tête flottant. */
  (function () {
    function ouvrirDepuisAncre() {
      var id = decodeURIComponent((window.location.hash || '').slice(1));
      if (!id) return;
      var item = document.getElementById(id);
      if (!item || !item.matches('details.faq-relia__item')) return;
      var cat = item.closest('details.faq-relia__category');
      if (cat) cat.open = true;
      item.open = true;
      window.requestAnimationFrame(function () {
        var haut = item.getBoundingClientRect().top + window.pageYOffset - 160;
        window.scrollTo({ top: haut, behavior: 'smooth' });
      });
    }
    window.addEventListener('hashchange', ouvrirDepuisAncre);
    window.addEventListener('load', ouvrirDepuisAncre);
  })();

  /* « Une seule question ouverte à la fois » : l'attribut name des <details>
     le fait nativement ; ce relais couvre les navigateurs qui l'ignorent. */
  document.addEventListener('toggle', function (event) {
    var item = event.target;
    if (!item.matches || !item.matches('details.faq-relia__item[name], details.faq-relia__category[name]') || !item.open) return;
    document.querySelectorAll('details[name="' + item.getAttribute('name') + '"][open]').forEach(function (autre) {
      if (autre !== item) autre.open = false;
    });
  }, true);

  (function () {
    function norm(s) {
      return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    function bind(input) {
      if (input.dataset.faqBound) return;
      input.dataset.faqBound = '1';

      function run() {
        var q = norm(input.value.trim());
        var items = document.querySelectorAll('.faq-relia__item');
        var anyVisible = false;

        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          if (!q) {
            it.hidden = false;
            it.open = false;
            continue;
          }
          var match = norm(it.textContent).indexOf(q) !== -1;
          it.hidden = !match;
          it.open = match;
          if (match) anyVisible = true;
        }

        var groups = document.querySelectorAll('.faq-relia__group');
        for (var g = 0; g < groups.length; g++) {
          var hasVisible = groups[g].querySelector('.faq-relia__item:not([hidden])');
          groups[g].hidden = q ? !hasVisible : false;
          var cat = groups[g].querySelector('.faq-relia__category');
          if (cat) cat.open = q ? !!hasVisible : false;
        }

        var noRes = document.querySelector('.faq-relia__noresults');
        if (noRes) noRes.hidden = !q || anyVisible;
      }

      input.addEventListener('input', run);
      input.addEventListener('search', run);
    }

    function init() {
      var inputs = document.querySelectorAll('.faq-relia__search-input');
      for (var i = 0; i < inputs.length; i++) bind(inputs[i]);
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setHeaderBottom();

      window.matchMedia('(max-width: 990px)').addEventListener('change', () => {
        this.setHeaderHeight();
        this.setHeaderBottom();
      });

      if ('ResizeObserver' in window) {
        new ResizeObserver(this.setHeaderBottom.bind(this)).observe(this);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    // Bas reel de la pilule quand le header est colle en haut (marge haute comprise).
    // Sert de repere aux colonnes sticky (photo + infos produit) pour rester dessous.
    setHeaderBottom() {
      const marginTop = parseFloat(getComputedStyle(this).marginTop) || 0;
      document.documentElement.style.setProperty('--header-bottom', `${Math.round(this.offsetHeight + marginTop)}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-bijoux-points"] && !Shopify.designMode) return;
  try {
    
  class ShoppableImage extends HTMLElement {
    connectedCallback() {
      this.points = Array.from(this.querySelectorAll('.shoppable__point'));
      this.slides = Array.from(this.querySelectorAll('.shoppable__slide'));
      this.track = this.querySelector('[id^="Slider-"]');
      this.segmentsTrack = this.querySelector('.slider-segments');
      this.segments = [];
      // Slides dans l'ordre réellement affiché (bijoux épuisés en fin de liste).
      this.visual = [];

      this.media = this.querySelector('.shoppable__media');
      this.slider = this.querySelector('.shoppable__slider');


      this.points.forEach((point) => {
        point.addEventListener('click', () => {
          this.goToIndex(parseInt(point.dataset.index, 10));
          // Mobile : le carrousel est sous la photo. On fait défiler la page
          // vers lui pour montrer le bijou cliqué (sinon il reste sous le pli).
          this.scrollSliderIntoView();
        });

        // Cale la bulle pour qu'elle reste dans le cadre de l'image (desktop).
        const tooltip = point.querySelector('.shoppable__tooltip');
        if (tooltip) {
          point.addEventListener('mouseenter', () => this.positionTooltip(tooltip));
          point.addEventListener('focus', () => this.positionTooltip(tooltip));
        }
      });

      // Barre de balayage à segments + synchro du point actif au défilement.
      this.refreshVisual();
      if (this.track) {
        this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
        const resync = () => {
          this.refreshVisual();
          this.onScroll();
        };
        window.addEventListener('resize', resync);
        // Le passage desktop <-> mobile change les bijoux affichés ET leur ordre
        // (un bijou peut être épuisé d'un côté seulement) : on resynchronise.
        const desktop = window.matchMedia('(min-width: 750px)');
        if (desktop.addEventListener) desktop.addEventListener('change', resync);
      }

      this.initDrag();
      // On démarre sur le premier bijou affiché (pas forcément le premier bloc :
      // un bijou épuisé est renvoyé en fin de défilement).
      this.setActive(this.visual.length ? Number(this.visual[0].dataset.index) : 0);
    }

    // Clic-glisse a la souris pour balayer le carrousel.
    // Fonctionne dans les deux sens : vertical sur desktop, horizontal sur mobile.
    // Le tactile garde le defilement natif.
    initDrag() {
      const track = this.track;
      if (!track) return;

      let isDown = false;
      let startX = 0;
      let startY = 0;
      let startLeft = 0;
      let startTop = 0;
      let moved = false;
      let pointerId = null;

      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        isDown = true;
        moved = false;
        startX = e.clientX;
        startY = e.clientY;
        startLeft = track.scrollLeft;
        startTop = track.scrollTop;
        pointerId = e.pointerId;
      });

      track.addEventListener('pointermove', (e) => {
        if (!isDown) return;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        // On ne capture le pointeur (et on bloque le clic) QUE si un vrai glisse
        // est detecte. Un simple clic n'est pas capture -> il ouvre la fiche produit.
        if (!moved && (Math.abs(dx) > 3 || Math.abs(dy) > 3)) {
          moved = true;
          track.classList.add('is-dragging');
          try {
            track.setPointerCapture(pointerId);
          } catch (err) {}
        }
        if (moved) {
          track.scrollLeft = startLeft - dx;
          track.scrollTop = startTop - dy;
        }
      });

      const end = () => {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
      };
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);

      // Bloque le glisser-deposer natif des images/liens : sinon il vole le geste
      // de balayage avant que le seuil de drag ne s'enclenche. N'affecte pas le clic.
      track.addEventListener('dragstart', (e) => {
        e.preventDefault();
      });

      // Si on vient de glisser, ne pas ouvrir la fiche produit au relachement.
      track.addEventListener(
        'click',
        (e) => {
          if (moved) {
            e.preventDefault();
            e.stopPropagation();
            moved = false;
          }
        },
        true
      );
    }

    positionTooltip(tooltip) {
      if (window.innerWidth < 750 || !this.media) return;
      tooltip.style.marginLeft = '0px';
      tooltip.style.setProperty('--arrow-shift', '0px');
      const pad = 8;
      const mediaRect = this.media.getBoundingClientRect();
      const tipRect = tooltip.getBoundingClientRect();
      let shift = 0;
      if (tipRect.left < mediaRect.left + pad) {
        shift = mediaRect.left + pad - tipRect.left;
      } else if (tipRect.right > mediaRect.right - pad) {
        shift = mediaRect.right - pad - tipRect.right;
      }
      if (shift) {
        tooltip.style.marginLeft = shift + 'px';
        tooltip.style.setProperty('--arrow-shift', -shift + 'px');
      }
    }

    // Recalcule l'ordre d'affichage des bijoux :
    // - on écarte les slides masquées (points "mobile uniquement" sur desktop) ;
    // - on applique l'ordre visuel du flex (CSS `order`), qui renvoie les bijoux
    //   épuisés en fin de défilement.
    // L'index d'une slide dans le DOM (data-index, celui des points) ne
    // correspond donc plus à sa position affichée : on passe par cette liste.
    refreshVisual() {
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;
      const shown = this.slides
        .filter((slide) =>
          isDesktop ? slide.dataset.mobileOnly !== 'true' : slide.dataset.desktopOnly !== 'true'
        )
        .map((slide, i) => ({
          slide: slide,
          order: parseInt(getComputedStyle(slide).order, 10) || 0,
          i: i,
        }));
      shown.sort((a, b) => a.order - b.order || a.i - b.i);
      this.visual = shown.map((entry) => entry.slide);
      this.buildSegments(this.visual.length);
    }

    buildSegments(count) {
      if (!this.segmentsTrack || this.segments.length === count) return;
      this.segmentsTrack.innerHTML = '';
      this.segments = [];
      for (let i = 0; i < count; i++) {
        const seg = document.createElement('span');
        seg.className = 'slider-segments__seg';
        this.segmentsTrack.appendChild(seg);
        this.segments.push(seg);
      }
    }

    onScroll() {
      if (!this.track) return;
      const total = this.visual.length;
      if (total < 2) return;
      const isVertical = getComputedStyle(this.track).flexDirection === 'column';
      let maxScroll;
      let pos;
      if (isVertical) {
        maxScroll = this.track.scrollHeight - this.track.clientHeight;
        pos = this.track.scrollTop;
      } else {
        maxScroll = this.track.scrollWidth - this.track.clientWidth;
        pos = this.track.scrollLeft;
      }
      const progress = maxScroll > 0 ? pos / maxScroll : 0;
      let current = Math.round(progress * (total - 1));
      if (current < 0) current = 0;
      if (current > total - 1) current = total - 1;
      if (isVertical) {
        // Desktop : on ne met à jour que la barre (le point actif reste celui cliqué).
        this.setActiveSegment(current);
      } else {
        // Mobile : barre + point + slide. `current` est une position affichée,
        // on la retraduit en index de bloc.
        const slide = this.visual[current];
        if (slide) this.setActive(Number(slide.dataset.index));
      }
    }

    setActiveSegment(index) {
      this.segments.forEach((seg, i) => seg.classList.toggle('is-active', i === index));
    }

    // Mobile uniquement : amène le carrousel des bijoux dans le champ de vision
    // (il est placé sous la photo). Sur desktop il est déjà à côté de l'image.
    scrollSliderIntoView() {
      if (window.innerWidth >= 750 || !this.slider) return;
      const rect = this.slider.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      // Déjà entièrement visible ? on ne bouge pas la page.
      if (rect.top >= 0 && rect.bottom <= vh) return;
      // Aligne le bas du carrousel sur le bas de l'écran : le carrousel apparaît
      // entièrement en bas, en gardant un maximum de la photo visible au-dessus.
      const margin = 16;
      const target = window.scrollY + rect.bottom - vh + margin;
      window.scrollTo({ top: Math.max(target, 0), behavior: 'smooth' });
    }

    goToIndex(index) {
      const slide = this.slides[index];
      if (slide && this.track) {
        const trackRect = this.track.getBoundingClientRect();
        const slideRect = slide.getBoundingClientRect();
        const isVertical = getComputedStyle(this.track).flexDirection === 'column';
        if (isVertical) {
          const delta = slideRect.top - trackRect.top;
          this.track.scrollTo({ top: this.track.scrollTop + delta, behavior: 'smooth' });
        } else {
          const delta = slideRect.left - trackRect.left;
          this.track.scrollTo({ left: this.track.scrollLeft + delta, behavior: 'smooth' });
        }
      }
      this.setActive(index);
    }

    setActive(index) {
      if (index < 0 || index >= this.slides.length) return;
      this.activeIndex = index;
      this.points.forEach((point, i) => point.classList.toggle('is-active', i === index));
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      // Le segment correspond à la position affichée, pas à l'index du bloc.
      const pos = this.visual.indexOf(this.slides[index]);
      if (pos !== -1) this.setActiveSegment(pos);
    }
  }

  if (!customElements.get('shoppable-image')) {
    customElements.define('shoppable-image', ShoppableImage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticket-or-banniere"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function majFrises() {
      var maintenant = Date.now() / 1000;
      document.querySelectorAll('.ticket-banniere__frise').forEach(function (frise) {
        var debut = parseInt(frise.dataset.debut, 10);
        var fin = parseInt(frise.dataset.fin, 10);
        var part = Math.min(1, Math.max(0, (maintenant - debut) / (fin - debut)));
        frise.querySelector('.ticket-banniere__frise-remplie').style.width = (part * 100).toFixed(2) + '%';
        frise.setAttribute('aria-valuenow', Math.round(part * 100));
      });
    }
    majFrises();
    setInterval(majFrises, 30000);
    document.addEventListener('shopify:section:load', majFrises);
  })();

  (function () {
    var bouton = document.querySelector('.ticket-flottant');
    if (!bouton) return;
    /* Rattaché au <body> : un parent transformé casserait le position: fixed. */
    if (bouton.parentElement !== document.body) document.body.appendChild(bouton);
    var cible = document.getElementById((bouton.getAttribute('href') || '').slice(1));
    var pied = document.querySelector('.footer, footer, [id*="__footer"]');
    var attente = false;

    function hauteurAccrocheKlaviyo() {
      var accroche = document.querySelector('[class*="kl-teaser"]');
      if (!accroche) return 0;
      var r = accroche.getBoundingClientRect();
      if (r.height === 0 || r.top >= window.innerHeight) return 0;
      return window.innerHeight - r.top;
    }

    function maj() {
      attente = false;
      if (!cible) return;
      var succes = document.getElementById('VipSucces');
      var inscrite = succes && succes.classList.contains('is-visible');
      var formDepasse = cible.getBoundingClientRect().bottom < 0;
      var piedVisible = pied && pied.getBoundingClientRect().top < window.innerHeight;
      var visible = formDepasse && !piedVisible && !inscrite;
      var klaviyo = hauteurAccrocheKlaviyo();
      bouton.style.setProperty('--ticket-flottant-bas', klaviyo > 0 ? (klaviyo + 10) + 'px' : '1.6rem');
      bouton.classList.toggle('is-visible', visible);
      bouton.setAttribute('aria-hidden', visible ? 'false' : 'true');
      bouton.tabIndex = visible ? 0 : -1;
    }

    function demander() {
      if (attente) return;
      attente = true;
      window.requestAnimationFrame(maj);
    }

    window.addEventListener('scroll', demander, { passive: true });
    window.addEventListener('resize', demander);
    setInterval(maj, 1500);
    maj();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticket-or-etapes"] && !Shopify.designMode) return;
  try {
    
  /* Liens des étapes (et bouton de la bannière) vers une section de la page : on centre la section à
     l'écran au lieu de la coller en haut. Si elle est plus haute que l'écran,
     on la cale juste sous le header flottant pour que son titre reste visible. */
  document.addEventListener('click', function (event) {
    var lien = event.target.closest('.ticket-etapes a[href^="#"], .ticket-cartes a[href^="#"], .faq-relia a[href^="#"], .ticket-banniere__bouton[href^="#"], .ticket-flottant[href^="#"]');
    if (!lien) return;
    var cible = document.getElementById(lien.getAttribute('href').slice(1));
    if (!cible) return;
    event.preventDefault();
    /* Cible dans un accordéon (question de la FAQ) : on l'ouvre, ainsi que ses parents, avant de mesurer. */
    for (var d = cible; d; d = d.parentElement) {
      if (d.tagName === 'DETAILS' && !d.open) d.open = true;
    }
    var header = document.querySelector('.section-header, sticky-header, .header-wrapper');
    var hauteurHeader = header ? header.getBoundingClientRect().bottom : 0;
    var zone = window.innerHeight - Math.max(hauteurHeader, 0);
    var rect = cible.getBoundingClientRect();
    var haut = window.scrollY + rect.top;
    var y = rect.height < zone - 32
      ? haut - Math.max(hauteurHeader, 0) - (zone - rect.height) / 2
      : haut - Math.max(hauteurHeader, 0) - 16;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    if (history.replaceState) history.replaceState(null, '', lien.getAttribute('href'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticket-or-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vip-countdown-timer')) {
    class VipCountdownTimer extends HTMLElement {
      connectedCallback() {
        this.endMs = parseInt(this.dataset.end, 10) * 1000;
        this.values = {
          jours: this.querySelector('[data-unit="jours"]'),
          heures: this.querySelector('[data-unit="heures"]'),
          minutes: this.querySelector('[data-unit="minutes"]'),
          secondes: this.querySelector('[data-unit="secondes"]')
        };
        this.tick = this.tick.bind(this);
        this.tick();
        this.interval = setInterval(this.tick, 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        const totalSeconds = Math.max(0, Math.floor((this.endMs - Date.now()) / 1000));
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        this.values.jours.textContent = String(days).padStart(2, '0');
        this.values.heures.textContent = String(hours).padStart(2, '0');
        this.values.minutes.textContent = String(minutes).padStart(2, '0');
        this.values.secondes.textContent = String(seconds).padStart(2, '0');
        if (totalSeconds <= 0) {
          clearInterval(this.interval);
          if (!Shopify.designMode) this.style.display = 'none';
        }
      }
    }
    customElements.define('vip-countdown-timer', VipCountdownTimer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vip-inscription"] && !Shopify.designMode) return;
  try {
    
  class VipCountdownTimer extends HTMLElement {
    connectedCallback() {
      this.endMs = parseInt(this.dataset.end, 10) * 1000;
      this.values = {
        jours: this.querySelector('[data-unit="jours"]'),
        heures: this.querySelector('[data-unit="heures"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        secondes: this.querySelector('[data-unit="secondes"]')
      };
      this.tick = this.tick.bind(this);
      this.tick();
      this.interval = setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const totalSeconds = Math.max(0, Math.floor((this.endMs - Date.now()) / 1000));
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.values.jours.textContent = String(days).padStart(2, '0');
      this.values.heures.textContent = String(hours).padStart(2, '0');
      this.values.minutes.textContent = String(minutes).padStart(2, '0');
      this.values.secondes.textContent = String(seconds).padStart(2, '0');

      if (totalSeconds <= 0) {
        clearInterval(this.interval);
        // le drop est passé : on masque le compte à rebours, pas de faux zéro
        if (!Shopify.designMode) this.style.display = 'none';
      }
    }
  }

  if (!customElements.get('vip-countdown-timer')) {
    customElements.define('vip-countdown-timer', VipCountdownTimer);
  }

  } catch(e) { console.error(e); }
})();
})();
